import { useEffect } from 'react';

import { usePlayerResolvedAnimation } from '@cartwhl/3d/player';

import { ENABLE_MOTION_EDITOR_KEY_POSE_SURFACES } from '../../feature-flags';
import { useStore as useMotionEditorStore } from '../../motionEditorStore';
import { getSourceBvhForTimeline } from '../keyPoseFrameMapping';
import {
  resolveActiveKeyPoseReferenceName,
  resolveSelectedKeyPoseMotionForReference,
} from '../keyPoseMotionUtils';
import { warnLongSourceMotionEditingIfNeeded } from '../keyPoseSourceMotionLimits';
import { selectUserKeyPoseRecordsForReference } from '../keyPoseSelectors';
import { useStore as useKeyPoseStore } from '../keyPoseStore';

export function useLongSourceMotionEditingWarning() {
  const motionEditorStore = useMotionEditorStore();
  const keyPoseStore = useKeyPoseStore();
  const { scene, playback } = motionEditorStore.state;
  const activeReferenceName = resolveActiveKeyPoseReferenceName(
    keyPoseStore.state.activeReferenceName,
    playback.selectedReferenceName,
    playback.sceneActors,
  );
  const resolvedAnimation = usePlayerResolvedAnimation(
    activeReferenceName ?? undefined,
  );
  const selectedKeyPoseMotion = activeReferenceName
    ? resolveSelectedKeyPoseMotionForReference(
        activeReferenceName,
        playback.selectedReferenceName,
        playback.selectedSceneMotion,
        playback.sceneActors,
      )
    : null;
  const sourceBvh = getSourceBvhForTimeline(
    resolvedAnimation.bvh,
    resolvedAnimation.bvhs,
    selectedKeyPoseMotion?.timelineIndex,
  );
  const userKeyPoseCount = selectUserKeyPoseRecordsForReference(
    keyPoseStore.state,
    activeReferenceName,
  ).length;

  useEffect(() => {
    if (
      !ENABLE_MOTION_EDITOR_KEY_POSE_SURFACES ||
      !scene.data ||
      !activeReferenceName ||
      !selectedKeyPoseMotion
    ) {
      return;
    }

    warnLongSourceMotionEditingIfNeeded({
      sceneID: scene.data.sceneID,
      referenceName: activeReferenceName,
      timelineIndex: selectedKeyPoseMotion.timelineIndex,
      sourceBvh,
      userKeyPoseCount,
    });
  }, [
    activeReferenceName,
    scene.data,
    selectedKeyPoseMotion,
    sourceBvh,
    userKeyPoseCount,
  ]);
}
